import { containsKey } from "./contains-key";

export function isWheels(category?: string) {
  if (!category) {
    return false;
  }
  return containsKey(category, ["wheels", "roues"]);
}
